import getCSSVarMap from '@m/theme/helpers/getCSSVarMap';

/**
 * Injects CSS variables into document root
 */
function injectCssVariables(vars: { [key: string]: string | number }) {
  const { documentElement: root } = document;
  Object.entries(vars).forEach(([key, val]) => {
    root.style.setProperty(key, `${val}`);
  });
}

// Just using a copy of the variables from postcss.config.js
// Babel seems to have trouble with imports outside of /src
// We should work on phasing out these variables and move to
// the theme package
const legacyVariables = {
  // '--variableName': 'css value',
  '--page-background': '#191c1f',

  '--nav-background': '#0d1013',

  '--card-background': '#393f45',
  '--card-background-rgb': '57,63,69',

  '--status-neutral': '#2F3B41',
  '--status-neutral-rgb': '47,59,65',

  '--accent': '#40bbff',
  '--accent-rgb': '64,187,255',

  '--customer-med-blue': '#5F59FF',
  '--customer-med-blue-rgb': '95,89,255',
  '--customer-med-blue-inactive': '#AFACFF',
  '--customer-orange': '#C83F34',
  '--customer-coral': '#FF5D52',
  '--customer-grey-1': '#a4a4ad',
  '--customer-grey-3': '#666666',
  '--customer-black': '#191919',
  '--customer-med-yellow': '#FAD148',
  '--customer-med-green': '#0F8F4D',
};

injectCssVariables(legacyVariables);
injectCssVariables(getCSSVarMap());
